import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cuándo lo tomo?',
  a: 'Elige 1 horario fijo: desayuno o merienda (te guiamos para escoger).'
}, {
  q: '¿Y si un smoothie me hincha?',
  a: 'Sigues el protocolo de ajuste 72h (bajas fibra/crudos/cítricos y continúas).'
}, {
  q: '¿Necesito ingredientes raros?',
  a: 'No. Ingredientes normales y fáciles de conseguir.'
}, {
  q: '¿Puedo hacerlo sin lácteos?',
  a: 'Sí. Incluye versión sin lácteos y sustituciones.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section background="white" data-id="element-22">
      <div className="text-center mb-8 md:mb-12" data-id="element-23">
        <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#2D2A26] mb-3 md:mb-4" data-id="element-24">
          Preguntas rápidas
        </h2>
      </div>

      <div className="max-w-2xl mx-auto space-y-3 md:space-y-4" data-id="element-25">
        {faqs.map((faq, index) => <div key={index} className="border border-[#E8E2DA] rounded-lg overflow-hidden bg-[#FAF7F2]" data-id="element-26">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 md:p-5 text-left focus:outline-none" data-id="element-27">
              <span className="font-serif font-bold text-[#2D2A26] text-base md:text-lg" data-id="element-28">
                {faq.q}
              </span>
              <ChevronDown className={`h-5 w-5 text-[#5B7C5B] transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-29" />
            </button>
            <AnimatePresence data-id="element-30">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-31">
                  <div className="p-4 md:p-5 pt-0 text-[#6B6560] border-t border-[#E8E2DA]/50 text-sm md:text-base" data-id="element-32">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}